import React from 'react';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import { Typography } from 'ha/ui/next/Typography';
import Grid from 'ha/ui/next/Grid';
import { useIntl } from 'ha/i18n';

import { getBillsLabel } from './utils/getBillsLabel';

import { ListingAttributes } from './types';

interface Props {
  room: ListingAttributes;
}

const useStyles = makeStyles(theme => ({
  price: {
    marginRight: theme.spacing(1),
    fontSize: '1.875rem',
  },
  shadow: {
    textShadow: '0 2px 2px rgba(0, 0, 0, 0.7)',
  },
}));

const Price: React.FC<Props> = ({ room }) => {
  const classes = useStyles();
  const { T } = useIntl();

  const price = Math.floor(room.price / 100).toString();

  return (
    <div>
      <Typography.ParagraphTitle
        className={classes.shadow}
        color="white"
        fontWeight="bold"
        lineHeight={1}
      >
        {room.currency}
      </Typography.ParagraphTitle>
      <Grid container>
        <meta itemProp="price" content={price} />
        <meta itemProp="priceCurrency" content={room.currency} />
        <Typography.H1
          component="span"
          color="white"
          lineHeight={1}
          className={cx(classes.price, classes.shadow)}
        >
          {price}
        </Typography.H1>
        <div>
          <Typography.Caption
            color="white"
            className={classes.shadow}
            lineHeight={1}
            fontWeight="bold"
          >
            {T('Monthly')}
          </Typography.Caption>
          <Typography.Caption
            color="white"
            className={classes.shadow}
            lineHeight={1}
            fontWeight="bold"
          >
            {getBillsLabel(room, T)}
          </Typography.Caption>
        </div>
      </Grid>
    </div>
  );
};

export default Price;
